import { type SvgIconProps } from '@mui/material';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import MemoryIcon from '@mui/icons-material/Memory';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import EvStationIcon from '@mui/icons-material/EvStation';
import BalconyIcon from '@mui/icons-material/Balcony';
import BuildIcon from '@mui/icons-material/Build';
import HomeIcon from '@mui/icons-material/Home';
import ForumIcon from '@mui/icons-material/Forum';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HandymanIcon from '@mui/icons-material/Handyman';
import BoltIcon from '@mui/icons-material/Bolt';
import VerifiedIcon from '@mui/icons-material/Verified';
import SavingsIcon from '@mui/icons-material/Savings';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

/**
 * Explicit allow-list rather than a dynamic import: it keeps the bundle small
 * and means a bad icon name in the CMS can never break the page.
 */
export const ICON_MAP = {
  SolarPower: SolarPowerIcon,
  Memory: MemoryIcon,
  BatteryChargingFull: BatteryChargingFullIcon,
  EvStation: EvStationIcon,
  Balcony: BalconyIcon,
  Build: BuildIcon,
  Home: HomeIcon,
  Forum: ForumIcon,
  FactCheck: FactCheckIcon,
  ShoppingCart: ShoppingCartIcon,
  Handyman: HandymanIcon,
  Bolt: BoltIcon,
  Verified: VerifiedIcon,
  Savings: SavingsIcon,
  Visibility: VisibilityIcon,
  ThumbUp: ThumbUpIcon,
} as const;

export type IconName = keyof typeof ICON_MAP;
export const ICON_NAMES = Object.keys(ICON_MAP) as IconName[];

export function DynamicIcon({ name, ...props }: { name: string } & SvgIconProps) {
  const Icon = ICON_MAP[name as IconName] ?? BoltIcon;
  return <Icon {...props} />;
}
